import moment from 'moment';
import { getOrdinal } from './common.utils';

export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const DEFAULT_TIME_FORMAT_DATE = 'MMM, YYYY';
export function formatDate(input: string | Date | undefined, format = DEFAULT_DATE_FORMAT): string {
	if (!input) {
		return '';
	}
	const mm = moment(input);
	if (mm.isValid()) {
		return mm.format(format);
	}
	return '';
}

export const getUnixTimestamp = (date: Date) => {
	return moment(date).unix() * 1000;
};

export function toOrdinalNumberDate(input: Date, format = DEFAULT_TIME_FORMAT_DATE): string {
	const mm = moment(input);
	const day = mm.get('D');
	const ordinal = getOrdinal(day);
	const rs = `${day}<sup>${ordinal}</sup> ${mm.format(format)}`;
	return rs;
}
